import React, { useState, useContext, useEffect } from 'react'
import styles from './location-details.module.scss'
import Button from 'src/components/button/Button'
import Input from 'src/components/input/Input'
import { baseApiURL } from 'src/utils/utils'
import { StateContext } from '../../AppContext'
import { IState, IAddress } from 'src/Interface'
import AutocompletePoi from 'src/components//autocomplete/AutocompletePoi'
import axios from 'axios'
import { toast } from 'react-toastify'
import { validEmail, validString } from 'src/utils/utils'
import { DispatchContext } from 'src/AppContext'


interface IValues {
  name: string,
  contactPerson: string
  email: string
  address: IAddress
}

interface IErrors {
  name: boolean,
  contactPerson: boolean
  email: boolean
}

interface IProps {
  close?: any
  branchId: number
  companyId: number
}

const LocationDetails: React.FunctionComponent<IProps> = ({ close, branchId, companyId }: IProps) => {
  const dispatch = useContext(DispatchContext)
  const state: IState = useContext(StateContext)
  const [values, setValues] = useState<IValues>({
    name: null,
    contactPerson: null,
    email: null,
    address: null
  })
  const [errors, setErrors] = useState<IErrors>({
    name: false,
    contactPerson: false,
    email: false
  })

  useEffect(() => {
    setValues({
      name: state.branch.name,
      contactPerson: state.branch.contactPerson,
      email: state.branch.email,
      address: state.branch.address
    })
  }, [state.branch])

  const handleInputChange = (fieldName: string) => (value: string) => {
    setValues({
      ...values,
      [fieldName]: value
    })
  }

  const handleValidation = (regexp: RegExp, fieldName: string) => (value: string) => {
    let error = false
    if (value && regexp && !regexp.test(value || '')) {
      error = true
    }
    setErrors({
      ...errors,
      [fieldName]: error
    })
  }

  const resetError = (fieldName: string) => {
    setErrors({
      ...errors,
      [fieldName]: false
    })
  }

  const toggleCompanyStatus = () => {
    axios.post(`${baseApiURL()}/companies/${companyId}/branches/${branchId}/status`,
      {
        active: state.branch.status === 'ACTIVE' ? false : true
      }, {
      headers: {
        Authorization:
          `Bearer ${state.user.accessToken}`
      }
    }).then(() => {
      return null;
    }).then(() => {
      return axios(`${baseApiURL()}/companies/${companyId}/branches/${branchId}`, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      })
    }).then((result: any) => {
      dispatch({ type: 'SET_BRANCH', branch: result.data })
      toast(state.branch.status === 'ACTIVE' ? 'Afdelingen er blevet deaktiveret' : 'Afdelingen er blevet genaktiveret')
      close()
    }).catch((err: any) => {
      toast(err.response.data.message)
    })
  }

  const updateBranch = () => {
    if (state.user.accessToken) {
      axios.put(`${baseApiURL()}/companies/${companyId}/branches/${branchId}`,
        {
          name: values.name ? values.name : null,
          contactPerson: values.contactPerson ? values.contactPerson : null,
          email: values.email ? values.email : null,
          status: 'ACTIVE',
          address: values.address
        }, {
        headers: {
          Authorization:
            `Bearer ${state.user.accessToken}`
        }
      }).then(() => {
        return null
      }).then(() => {
        axios(`${baseApiURL()}/companies/${companyId}/branches/${branchId}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then((result: any) => {
          dispatch({ type: 'SET_BRANCH', branch: result.data })
          close()
        })

        axios(`${baseApiURL()}/companies/${companyId}`, {
          headers: {
            Authorization:
              `Bearer ${state.user.accessToken}`
          }
        }).then((result: any) => {
          dispatch({ type: 'SET_COMPANY', company: result.data })
        })
      }).catch((error: any) => {
        if (error.response) {
          toast(error.response.data.message)
        } else {
          toast('Der gik desværre noget galt. Prøv igen om lidt')
        }
      })
    }
  }

  return (
    <>
      <header className={styles.header}>
        <h4>Oplysninger</h4>
        <span className={styles.closeIcon} onClick={close}>X</span>
      </header>
      <div className={styles.container}>
        <Input
          placeholder='Indtast firmanavn'
          modifiers='tw-mb-3'
          value={values.name}
          label='Firmanavn *'
          type='text'
          error={errors.name}
          resetError={() => resetError('name')}
          handleValidation={() => handleValidation(validString, 'name')}
          handleInputChange={() => handleInputChange('name')}
          name='name'
        />
        <AutocompletePoi
          completedAddress={values.address}
          modifiers='tw-mb-3'
          label='Kvikbestil adresse *'
          setAddress={() => handleInputChange('address')}
          name='addresse'
          placeholder='Indtast firmaadresse'
        />
        <Input
          placeholder='Indtast kontaktperson'
          modifiers='tw-mt-3'
          value={values.contactPerson}
          label='Kontakt person'
          error={errors.contactPerson}
          resetError={() => resetError('contactPerson')}
          type='text'
          handleValidation={() => handleValidation(validString, 'contactPerson')}
          handleInputChange={() => handleInputChange('contactPerson')}
          name='contactPerson'
        />
        <Input
          placeholder='Indtast email til kontaktperson'
          modifiers='tw-mt-3'
          value={values.email}
          label='Kontakt email'
          type='email'
          error={errors.email}
          resetError={() => resetError('email')}
          handleInputChange={() => handleInputChange('email')}
          handleValidation={() => handleValidation(validEmail, 'email')}
          name='email'
        />
      </div>
      <footer className={styles.footer}>
        <Button type='secondary' label='Annuller' modifiers='tw-ml-auto tw-mr-5' handleClick={close} />
        {state.branch.id !== state.user.branchId &&
          <>
            {state.branch.status === 'ACTIVE' ?
              <Button type='destructive' label='Arkiver' modifiers='tw-mr-5' handleClick={toggleCompanyStatus} /> :
              <Button type='primary' label='Aktivér' modifiers='tw-mr-5' handleClick={toggleCompanyStatus} />
            }
          </>
        }
        <Button type='primary' label='Tilføj' handleClick={updateBranch} />
      </footer>
    </>
  )
}

export default LocationDetails
